module.exports = __webpack_public_path__ + "static/media/SaaSbg4.5a7dbb80.png";